import { lazy } from 'react'

export const PresaleV1 = lazy(() => import('./v1/PresaleV1'))
export const PresaleV2 = lazy(() => import('./v2/PresaleV2'))
export const PresaleV3 = lazy(() => import('./v3/PresaleV3'))
export const PresaleV4 = lazy(() => import('./v4/PresaleV4'))
